import { injectable } from 'inversify';
import { iocContainer, TYPES } from '@/engine/ioc';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { CasePersistenceHub } from './CasePersistenceHub';
import type { CasePhaseData } from '../CasePhaseData/CasePhaseData.ts';
import type { IndicationsResolver } from '../IndicationsResolver';
import type { DiameterMeasurementsResolver } from '../DiameterMeasurementsResolver';
import type { OrientationPresetsResolver } from '../OrientationPresetsResolver';
import { ImagesGuidResolverCompatibilityHandler } from './ImagesGuidResolverCompatibilityHandler';
import { CasePhaseDataCompatibilityHandler } from './CasePhaseDataCompatibilityHandler';
import { PlanningAlgorithmCompatibilityHandler } from './PlanningAlgorithmCompatibilityHandler';
import { DiameterMeasurementsResolverCompatibilityHandler } from './DiameterMeasurementsResolverCompatibilityHandler';
import type { DistanceMeasurementsResolver } from '../DistanceMeasurementsResolver';
import type { CommissurePointsResolver } from '../CommissurePointsResolver.ts';

@injectable()
export class CasePersistenceRegistrar {
  public init(hub: CasePersistenceHub): void {
    hub.registerSubject('PlanningAlgorithm', iocContainer.get<PlanningAlgorithm>(TYPES.PlanningAlgorithm));
    hub.registerSubject('CasePhaseData', iocContainer.get<CasePhaseData>(TYPES.CasePhaseData), 'ImagesGuidResolver');
    hub.registerSubject('IndicationsResolver', iocContainer.get<IndicationsResolver>(TYPES.IndicationsResolver));
    hub.registerSubject(
      'DiameterMeasurementsResolver',
      iocContainer.get<DiameterMeasurementsResolver>(TYPES.DiameterMeasurementsResolver)
    );
    hub.registerSubject(
      'DistanceMeasurementsResolver',
      iocContainer.get<DistanceMeasurementsResolver>(TYPES.DistanceMeasurementsResolver)
    );

    hub.registerSubject(
      'CommissurePointsResolver',
      iocContainer.get<CommissurePointsResolver>(TYPES.CommissurePointsResolver)
    );

    hub.registerSubject(
      'OrientationPresetsResolver',
      iocContainer.get<OrientationPresetsResolver>(TYPES.OrientationPresetsResolver)
    );

    hub.registerBackwardCompatibilityHandler(
      new ImagesGuidResolverCompatibilityHandler(),
      'ImagesGuidResolver',
      ['1.0'],
      true
    );
    hub.registerBackwardCompatibilityHandler(new CasePhaseDataCompatibilityHandler(), 'CasePhaseData', [
      '1.0',
      '1.1',
      '1.2'
    ]);
    hub.registerBackwardCompatibilityHandler(new PlanningAlgorithmCompatibilityHandler(), 'PlanningAlgorithm', ['1.0']);
    hub.registerBackwardCompatibilityHandler(
      new DiameterMeasurementsResolverCompatibilityHandler(),
      'DiameterMeasurementsResolver',
      ['1.0']
    );
  }
}
